import React, { useContext, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { RxCross2 } from "react-icons/rx";
import AuthContext from "../../context/AuthContext";
import { isEmpty, isNumber } from "lodash";
import { apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { useContextSelector } from "use-context-selector";

const DialVelkie = ({ handleStackSetting }) => {
  const numberArrayCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, "", 0];
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const getProfileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.getProfileData;
  });
  const [focus, setFocus] = useState(0);
  const [stake, setStake] = useState(
    profileData?.stake?.slice(0, 4)?.length > 0
      ? profileData?.stake?.slice(0, 4)
      : profileData?.editStake?.slice(0, 4)
  );
  const handelDialPad = (item) => {
    if (isNumber(focus)) {
      setStake((prev) => {
        return prev?.map((res, index) => {
          if (index == focus) {
            return Number(res.toString() + item.toString());
          } else {
            return res;
          }
        });
      });
    }
  };

  const clear = () => {
    setStake((prev) => {
      return prev.map((res, index) => {
        if (index == focus && res?.toString()?.length > 0) {
          let num = Number(
            res.toString().substring(0, res.toString().length - 1)
          );
          return num;
        } else {
          return res;
        }
      });
    });
  };

  const submit = async () => {
    const { status, data: response_users } = await apiPost(
      apiPath.userProfileUpdate,
      {
        stake: stake,
      }
    );
    if (status === 200) {
      if (response_users.success) {
        getProfileData();
        handleStackSetting();
      }
    }
  };

  return (
    <div data-v-05b4889a data-v-b1b92075 className="setting-wrapper">
      <div
        data-v-05b4889a
        className="absolute top-0 w-full h-full z-50"
        style={{}}
      />
      <div
        data-v-05b4889a
        className="setting fixed z-50 container bottom-0"
        style={{}}
      >
        <div
          data-v-05b4889a
          className="setting-content bg-secondary flex flex-col p-1 pb-0 h-full overscroll-y-none rounded-t-xl"
        >
          <div
            data-v-05b4889a
            className="setting-header flex justify-center items-center py-2"
          >
            <span
              data-v-05b4889a
              className="setting-title mx-4 pb-2 text-pop-title font-bold"
            >
              Default stake setting
            </span>
            <div
              onClick={() => handleStackSetting()}
              data-v-05b4889a
              className="icon-close absolute right-2 top-4 justify-center items-center mr-2 cursor-pointer text-global-font-on-dark text-14"
            />
          </div>
          <div
            data-v-05b4889a
            className="bg-black-200 rounded-t-lg py-2 px-1 flex"
          >
            {stake?.map((res, index) => {
              return (
                <div
                  data-v-05b4889a
                  onClick={() => setFocus(index)}
                  className="input-box h-40px mx-1 flex-1 flex items-center justify-center"
                >
                  <span
                    data-v-05b4889a
                    name="index"
                    className={`sum w-10 h-10 flex-1 flex justify-center items-center font-bold overflow-hidden mx-1 rounded-lg border-solid text-global-font-on-light bg-white ${
                      focus == index ? "is-focus" : ""
                    } `}
                  >
                    {res}
                  </span>
                </div>
              );
            })}
          </div>
          <div data-v-05b4889a className="keyboard">
            <div
              data-v-05b4889a
              className="num grid grid-cols-3 bg-white p-2 pb-0"
            >
              {numberArrayCount?.map((res) => {
                return (
                  <button
                    data-v-05b4889a
                    className="calc-btn"
                    type="button"
                    onClick={() => {
                      if (isNumber(res)) {
                        if (
                          (stake
                            ?.find((res, index) => {
                              return index == focus;
                            })
                            ?.toString()?.length || 0) +
                            1 <=
                          5
                        ) {
                          handelDialPad(res);
                        }
                      }
                    }}
                  >
                    {res}
                  </button>
                );
              })}

              <button
                onClick={() => {
                  clear();
                }}
                data-v-05b4889a
                className="calc-btn icon-backspace text-25"
                type="button"
              />
            </div>
          </div>
          <div data-v-05b4889a className="bg-white px-2">
            <button
              onClick={() => {
                submit();
              }}
              data-v-05b4889a
              className="btn-normal p-3 font-bold rounded flex justify-center items-center disabled:bg-black-300 disabled:text-black-600 disabled:cursor-not-allowed w-full h-40px my-2"
              type="submit"
            >
              {/**/}Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DialVelkie;
